import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Logo from "../assets/images/logo-white.png";
import Footer from "../components/Navbar/Footer";
import { getLocalStorageData, setLocalStorageData } from "../utils/helpers/helpers";
import { post } from "../utils/helpers/http";
// import bcrypt from "bcryptjs";
import { FaEye, FaEyeSlash } from "react-icons/fa"; // Import icons
import accountLogo from "../assets/images/logo.png";


const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [disableLogin, setDisableLogin] = useState(false)
  const [showPassword, setShowPassword] = useState(false);

  const [error] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    let userData = getLocalStorageData("authorizationToken")
    console.log("rememberMe****", getLocalStorageData("rememberMe"));
    console.log("email****", getLocalStorageData("email"));
    console.log("pass****", getLocalStorageData("password"));
    if (getLocalStorageData("rememberMe")) {
      setEmail(getLocalStorageData("email"))
      setPassword(getLocalStorageData("password"))
    }
    if (userData) {
      navigate('/dashboard')
    }
  }, [navigate]);

  const handleRememberMeChange = () => {
    let remeberVal = rememberMe ? false : true;
    console.log("remebemr m,e fn****", remeberVal)
    setRememberMe(remeberVal);
  };
  const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      toast.error('Email / Password required');
      return;
    }
    if (!email) {
      toast.error('Email is required');
      return;
    }

    if (!password) {
      toast.error('Password is required');
      return;
    }
    if (!emailRegex.test(email)) {
      toast.error('Invalid email format');

      return;
    }
    if (!passwordRegex.test(password)) {
      toast.error("Incorrect password");
      return;
    }
    try {
      let reqBody = {
        email,
        // password: hashedPassword, 
        password
      }
      const response = await post('/Account/Login', reqBody)
      console.log("response******", response);
      const { userId, accessToken, authorizationToken, userType } = response.data.data;
     
      if (userType !== 1) {
        toast.error("Invalid credentials");
        return;
      }
      setLocalStorageData("userId", userId);;
      setLocalStorageData("accessToken", accessToken);
      setLocalStorageData("authorizationToken", authorizationToken);
      localStorage.setItem("loginTime", new Date().getTime().toString())

      if (rememberMe) {
        setLocalStorageData("rememberMe", true);
        setLocalStorageData("email", email);
        // setLocalStorageData("password", hashedPassword);
        setLocalStorageData("password", password);
      } else {
        localStorage.removeItem("rememberMe")
        localStorage.removeItem("email")
        localStorage.removeItem("password")
      }
      navigate("/dashboard");
    } catch (error) {
      toast.error("Invalid email or password.");
    }
  };

  return (
    <div className="accountBox">
      <div className="accountLeft">
        <div className="logo_account mb-5">
          <img src={Logo} alt="logo" />
        </div>
      </div>
      <div className="accountRight">
        <div className="account-body mt-auto">
          <div className="logo_account d-xl-none mb-5 text-center">
            <img src={accountLogo} height="80" alt="logo" />
          </div>
          <h3 className="text-center mb-4">
            <strong>Admin Login</strong>
          </h3>
          {error && <div className="alert alert-danger">{error}</div>}
          <form onSubmit={handleSubmit}>
            <div className="form-group mb-3">
              <label className="form-label">Email</label>
              <input
                type="text"
                className="form-control"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="form-group mb-3">
              <label className="form-label">Password</label>
              <div className="position-relative">
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control pr-5"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  style={{ paddingRight: "2.5rem" }}
                />
                {password && (
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      border: "none",
                      background: "transparent",
                      padding: 0,
                    }}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </button>
                )}
              </div>
            </div>



            <div className="form-group mb-3">
              <div className="float-start">
                <div className="checkbox rembermethis">
                  <input
                    type="checkbox"
                    value="remember-me"
                    id="rememberme"
                    checked={rememberMe}
                    onChange={handleRememberMeChange}
                  />
                  <label htmlFor="rememberme">Remember Me</label>
                </div>
              </div>
              <div className="float-end text-end">
                <Link className="fpass" to="/forgot-password">
                  Forgot password?
                </Link>
              </div>
            </div>
            <div className="form-group mt-5">
              <button
                type="submit"
                className="btn btn-primary w-100"
                disabled={disableLogin}
              >
                Login
              </button>
            </div>
          </form>
        </div>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          closeOnClick
          pauseOnHover
          draggable
          onOpen={() => {
            setDisableLogin(true);
            setTimeout(() => {
              setDisableLogin(false);
            }, 5000);
          }} />
        <Footer />
      </div>
    </div>
  );
};

export default Login;
